import React, { useEffect, useState } from 'react';
import { Check, Copy } from 'lucide-react';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';

const build = (p, link, user) => {
  const firmFull = (typeof user?.firm === 'object' ? user?.firm?.name : user?.firm) || user?.firmName || 'our team';
  const firm = firmFull.replace(/\.$/, '');
  const first = (p.contact || '').trim().split(' ')[0];
  return `Hi ${first || p.name},

Thank you for choosing ${firm}. We're looking forward to working with ${p.name}!

To get you set up, please complete your onboarding using the secure link below. It takes about 10 minutes, and you can stop and come back to it at any time:
${link}

On the link you'll be able to:
• confirm your business details
• review and sign our engagement letter and agreements online
• upload your FICA documents (ID, proof of address, bank confirmation and company documents)

Please keep this link private. It's unique to ${p.name}. If you have any questions, simply reply to this message. We're happy to help.

Kind regards,
${user?.name || ''}
${firmFull}`;
};

export const OnboardMessageDialog = ({ open, onOpenChange, prospect, link, user, toast }) => {
  const [msg, setMsg] = useState('');
  const [copied, setCopied] = useState(false);
  useEffect(() => { if (open) { setMsg(build(prospect, link, user)); setCopied(false); } }, [open, prospect, link, user]);
  const copy = () => navigator.clipboard.writeText(msg)
    .then(() => { setCopied(true); toast({ title: 'Message copied', description: 'Paste it into WhatsApp or email.' }); setTimeout(() => setCopied(false), 2500); })
    .catch(() => toast({ title: 'Could not copy', description: 'Select the message and copy it manually.', variant: 'destructive' }));
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg max-h-[92vh] overflow-y-auto" data-testid="onboard-message-dialog">
        <DialogHeader><DialogTitle>Send onboarding link</DialogTitle></DialogHeader>
        <div className="flex items-center justify-between">
          <span className="text-xs text-stone-600">Message to send (edit if you like)</span>
          <button type="button" onClick={() => setMsg(build(prospect, link, user))} className="text-xs text-stone-500 hover:text-emerald-800" data-testid="onboard-message-reset-btn">Reset</button>
        </div>
        <textarea value={msg} onChange={(e) => setMsg(e.target.value)} rows={16}
          className="w-full rounded-md border border-stone-200 bg-white p-3 text-sm leading-relaxed text-stone-800 focus:outline-none focus:ring-2 focus:ring-emerald-700/30" data-testid="onboard-message-textarea"/>
        <Button onClick={copy} className={`w-full h-10 ${copied ? 'bg-emerald-700 hover:bg-emerald-700' : 'bg-emerald-800 hover:bg-emerald-900'} text-white`} data-testid="onboard-copy-message-btn">
          {copied ? <><Check size={14} className="mr-1.5"/> Message copied</> : <><Copy size={14} className="mr-1.5"/> Copy message with link</>}
        </Button>
      </DialogContent>
    </Dialog>
  );
};
